import React from "react";
import "./TopNav.scss";
import { useSelector } from "react-redux";

const TopNav = () => {
  const user = useSelector((prev) => prev?.auth?.currentUser?.data);

  return (
    <div className="top-navbar">
      <div className="user-profile">
        <div className="user-image">
          {user?.username?.charAt(0)}
        </div>
        <div className="user-data">
          <p>{user?.username}</p>
          <h3>{user?.email}</h3>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
